<template>
  <!-- 监装 -->
  <div class="supervisionReportBasic">
    <!-- <p class="H-title">查看报告</p> -->
    <div class="reportBasic-con">
      <a-spin :spinning="spinning">
        <a-tabs defaultActiveKey="1" @change="callback">
          <a-tab-pane
            :tab="$tc('lang.LoadingReport.GENERAL_INFORMATION')"
            key="1"
          >
            <basic-information />
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.LoadingReport.Loading_Quantity')" key="2">
            <description-of-goods />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.LoadingReport.Packing_Information')"
            key="3"
          >
            <description-of-pack />
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.LoadingReport.Product_Details')" key="4">
            <product-details />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.LoadingReport.Truck_And_Container')"
            key="5"
          >
            <cart></cart>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.LoadingReport.Loading_Process')" key="6">
            <process-monitoring></process-monitoring>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.LoadingReport.Seal_Container')" key="7">
            <closures></closures>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.LoadingReport.Brief_Report')" key="8">
            <general-estimate />
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
    <!-- <div class="bottom-active">
      <div>
        <a-button type="primary" @click="goBack">立即返回</a-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import basicInformation from './supervisionComponents/basicInformation';
import descriptionOfGoods from './supervisionComponents/descriptionOfGoods';
import descriptionOfPack from './supervisionComponents/descriptionOfPack';
import productDetails from './supervisionComponents/productDetails';
import generalEstimate from './supervisionComponents/generalEstimate';
import cart from './supervisionComponents/cart';
import processMonitoring from './supervisionComponents/processMonitoring';
import closures from './supervisionComponents/closures';
export default {
  data() {
    return {
      id: this.$route.query.id,
      spinning: false,
    };
  },
  created() {
    this.getDetail();
  },
  components: {
    descriptionOfGoods, // 货物描述
    descriptionOfPack, // 包装描述
    productDetails, // 产品细节
    cart,
    closures,
    processMonitoring,
    basicInformation, // 基本信息
    generalEstimate, //总概
  },
  computed: {
    supervisionDetails: {
      get() {
        return this.$store.state.report.supervisionDetails;
      },
      set(val) {
        this.$store.commit('report/save', { supervisionDetails: val });
      },
    },
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    goBack() {
      this.$router.back(-1);
    },

    getDetail() {
      this.spinning = true;
      this.$http
        .post('/hzwmj/workorder-loadigreport/getData', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.supervisionDetails = data.data;
            this.spinning = false;
            this.getImg();
          } else {
            this.supervisionDetails = {};
            this.spinning = false;
          }
        })
        .catch(() => {
          this.supervisionDetails = {};
          this.spinning = false;
        });
    },
    getImg() {
      console.log(this.supervisionDetails.lreoprtId, 111);
      this.$store.dispatch(
        'report/getSupervisionImg',
        this.supervisionDetails.lreoprtId,
      );
    },
  },
};
</script>

<style lang="less">
.supervisionReportBasic {
  height: calc(100vh - 200px);
  overflow: hidden;
  text-align: left;
  margin-top: 35px;
  li {
    list-style: none;
  }

  .reportBasic-subTitle {
    background-color: #f6f6f6;
    padding: 5px 10px;
    margin: 10px 0;
  }
  .button-group {
    text-align: right;
    button {
      margin: 0 5px;
    }
  }
  .reportBasic-con {
    .ant-tabs-tabpane {
      padding: 0 10px 30px;
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
  }
}
</style>
